import leavePeriodTypesList from '../../data/leave-period-types.json';

import type { LeavePeriodLookupType } from './leave-period-lookup-type';

export const leavePeriodTypes: LeavePeriodLookupType[] = leavePeriodTypesList as LeavePeriodLookupType[];
